import { Provider } from '@angular/core';

export const COMMON_PIPES: Provider[] = [];
